<div class="modal-header">
    <h4 class="modal-title">{{confirmationBoxTitle}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{confirmationMessage}}</p>
  </div>
  <div class="modal-footer">
    <button *ngIf ="bevestig" type="button" class="btn btn-dark" (click)="activeModal.close(false)">Annuleer</button>
    <button type="button" class="btn btn-dark" (click)="activeModal.close(true)">Bevestig</button>
    
  </div>